import styles from "./PaginationDots.module.scss";

const PaginationDots = ({ count, activeIndex }) => {
    return (
        <div className={styles.dots} role="tablist">
            {Array.from({ length: count }).map((_, index) => (
                <span
                    key={index}
                    role="tab"
                    aria-selected={index === activeIndex}
                    className={`${styles.dot} ${index === activeIndex ? styles.active : ""
                        }`}
                />
            ))}
        </div>
    );
};

export default PaginationDots;
